import { motion } from 'framer-motion';

import { staggerItem } from '../ui/motionVariants';

interface DashboardHeroProps {
  firstName?: string | undefined | null;
}

export function DashboardHero({ firstName }: DashboardHeroProps): JSX.Element {
  const hour = new Date().getHours();
  let greeting = 'Good evening';
  if (hour < 12) greeting = 'Good morning';
  else if (hour < 18) greeting = 'Good afternoon';

  return (
    <motion.div
      variants={staggerItem}
      className="relative overflow-hidden rounded-3xl border border-border bg-cover bg-center min-h-[16rem] flex flex-col justify-end ring-1 ring-foreground/5 shadow-soft"
      style={{ backgroundImage: "url('/images/dashboard-hero.webp')" }}
    >
      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/10" />
      <div className="relative p-6 sm:p-8 text-white w-full flex flex-col sm:flex-row sm:items-end justify-between gap-6">
        <div className="max-w-xl">
          <h1 className="text-2xl sm:text-4xl font-display font-semibold tracking-tight text-white">
            {greeting}
            {firstName ? `, ${firstName}` : ''}
          </h1>
          <p className="text-sm sm:text-base text-white/80 mt-2 leading-relaxed">
            Here&rsquo;s what&rsquo;s waiting for you today. Let&rsquo;s make progress on your
            coaching journey and achieve your goals.
          </p>
        </div>
        <div className="rounded-2xl bg-black/20 backdrop-blur-md border border-white/20 p-4 min-w-[240px]">
          <p className="text-xs text-white/70 uppercase tracking-widest font-semibold mb-1">
            Focus for today
          </p>
          <p className="text-sm font-medium">
            Review your latest report and prepare for your upcoming session.
          </p>
        </div>
      </div>
    </motion.div>
  );
}
